export const environment = {
  production: true,

  // API via Traefik
  base_url: window.location.origin,

  // WebSocket via Traefik
  wsUrl:
    (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
    window.location.host +
    '/ws-chat',

  warning_icon: 'fa fa-exclamation-triangle',
  error_icon: 'fa fa-times-circle',
  info_icon: 'fa fa-exclamation-circle',

  info_message_type: 'Information',
  warning_message_type: 'Warning',
  error_message_type: 'Demande erronée',
};